import React, { useRef, useState, useEffect } from "react";
import classes from "./style.module.scss";
import ModalDropdown from "../../component/ModalDropdown";
import CloseIcon from "@mui/icons-material/Close";
import SelectBox from "../../component/SelectBox";
import Button from "../../component/Button";
import { FormProvider, useForm, Controller } from "react-hook-form";
import InputBox from "../../component/InputBox";
import FileUpload from "../../component/FileUpload";
import { saveLoadingState } from "../../redux/reducers/loadingSlice";
import { getDateFormat, singleUpload } from "../../helpers";
import Exported from "../../service/endpoints";
import request from "../../service";
import { Toast } from "../../service/toast";
import { useDispatch } from "react-redux";
import { CountryCode, getCountryCode } from '../../helpers';

const CreateNotifications = (props) => {
  const {
    isOpen = false,
    closePopUp,
    handleSuccessModal,
    handleScheduleModal,
    getNotificationList,
    notification_id,
    isEdit,
    setIsEdit,
  } = props;
  const selectBoxRef = useRef();
   const [countryList, setCountryCodes] = useState([]);
  
    useEffect(() => {
      getCountryCode()
        ?.then((code) => {
          // Transform API data into your desired format
          const formattedCountries = code.map((item) => ({
            label: item.country_name,
            value: item.id,
          }));
  
          // Add the static "All" option at the beginning
          const allOption = { label: "All", value: 100 };
          const finalCountryList = [allOption, ...formattedCountries];
  
          // Set the final list in state
          setCountryCodes(finalCountryList);
        })
        .catch((err) => {
          console.error("Error fetching country codes:", err);
        });
    }, []);

  const typeList = [
    { label: "General", value: "1" },
    { label: "Promotional", value: "2" },
    { label: "Alert", value: "3" },
  ];
  const recipientList = [
    { label: "Retailers", value: "1" },
    { label: "Mechanics", value: "2" },
    { label: "Both", value: "3" },
  ];
  // const countryList = [
  //   { label: "All", value: 100 },
  //   { label: "India", value: 1 },
  //   { label: "UAE", value: 2 },
  //   { label: "Saudi", value: 3 },
  //   { label: "Jordan", value: 4 },
  //   { label: "Zambia", value: 5 },
  //   { label: "Nigeria", value: 6 },
  //   { label: "Kenya", value: 7 },
  //   { label: "Tanzania", value: 8 },
  // ];

  const formMethods = useForm({
    mode: "onSubmit",
  });
  const {
    handleSubmit,
    formState: { errors },
    register,
    getValues,
    setValue,
    trigger,
  } = formMethods;

  const dispatch = useDispatch();
  const [fileName, setFileName] = useState(null);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(null);

  useEffect(() => {
    if (notification_id) {
      getDetails(notification_id);
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
  }, [notification_id]);

  const getDetails = async (notification_id) => {
    let url = `${Exported.Endpoints.getNotificationDetails}`;
    let paramsObj = {
      notification_id: notification_id,
    };
    await request({
      url: url,
      params: { ...paramsObj },
    })
      .then((res) => {
        if (res?.data?.status) {
          let detailInfo = res?.data?.data;
          setValue("title", detailInfo?.title);
          setValue("type", detailInfo?.type);
          setValue("recipient", detailInfo?.recipient);
          setValue("country_id", detailInfo?.country_id);
          setValue("message", detailInfo?.message);
          setValue("documents", detailInfo?.documents || null);
          setValue("scheduled_date", detailInfo?.scheduled_date || null);
          setValue("scheduled_time", detailInfo?.scheduled_time || null);
          setFileName([detailInfo?.documents]);
        }
      })
      .catch((err) => {
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
  };

  const onSubmit = async (data) => {
    trigger();
    dispatch(saveLoadingState(true));
    let uploadedObj = [];
    if (uploadedFiles && uploadedFiles.length > 0) {
      uploadedObj = await singleUpload(uploadedFiles);
    }
    let requestData = {
      title: data?.title,
      type: data?.type,
      recipient: data?.recipient,
      country_id: data?.country_id,
      message: data?.message,
      isSendNow: true,
      status: 1,
    };
    if (uploadedObj?.url) {
      requestData["documents"] = [uploadedObj?.url];
    } else if(data?.documents?.length > 0) {
      requestData["documents"] = data?.documents;
    }
    let paramsObj = {
      notification_id: notification_id,
    };

    await request({
      url: `${Exported.Endpoints.getNotificationDetails}`,
      method: isEdit ? Exported.APIMethods.PUT : Exported.APIMethods.POST,
      data: requestData,
      params: isEdit ? { ...paramsObj } : null,
    })
      .then((res) => {
        if (res?.data?.status) {
          dispatch(saveLoadingState(false));
          handleSuccessModal();
          getNotificationList();
        }
      })
      .catch((err) => {
        Toast({
          type: "error",
          message: err?.response?.data?.message || "Unable to process the request!..",
        });
      });
    dispatch(saveLoadingState(false));
  };

  const handleScheduler = async (event) => {
    event.preventDefault();

    const isValid = await trigger(); 

   if (!isValid) {
    Toast({
      type: "error",
      message: "Please fill all required fields before scheduling.",
    });
    return;
   }
   
    const formData = getValues();
    let uploadedObj = [];
    if (uploadedFiles && uploadedFiles.length > 0) {
      uploadedObj = await singleUpload(uploadedFiles);
    }
    if (uploadedObj?.url) {
      formData["documents"] = [uploadedObj?.url];
    }
    handleScheduleModal(formData, isEdit);
  };

  return (
    <>
      <ModalDropdown
        isOpen={isOpen}
        closePopUp={closePopUp}
        selectBoxRef={selectBoxRef}
      >
        <div className={`${classes.createNotificationWrapper}`}>
          <div
            className={`${classes.modalHeader} flex items-center justify-between`}
          >
            <div className={`${classes.modalTitle}`}>
              {isEdit ? "Edit" : "Create New"} Notification
            </div>
            <div className={`${classes.modalCloser}`}>
              <CloseIcon onClick={() => closePopUp()} />
            </div>
          </div>
          <div className={`${classes.reasonFormContainer}`}>
            <FormProvider {...formMethods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Title"}
                    className={`w-[100%]`}
                    name={"title"}
                    {...register("title", {
                      required: true,
                    })}
                    placeholder={"Title"}
                    error={errors.title}
                    messages={{
                      required: "Title is required",
                    }}
                    isEdit={isEdit}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="type"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Type"
                        placeholder="Type"
                        list={typeList}
                        isEdit={isEdit}
                        {...field}
                        error={errors.type}
                        messages={{
                          required: "Type is required",
                        }}
                      />
                    )}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="recipient"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Recipient"
                        placeholder="Recipient"
                        list={recipientList}
                        isEdit={isEdit}
                        {...field}
                        error={errors.recipient}
                        messages={{
                          required: "Recipient is required",
                        }}
                      />
                    )}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="country_id"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Country"
                        placeholder="Country"
                        list={countryList}
                        isEdit={isEdit}
                        {...field}
                        error={errors.country_id}
                        messages={{
                          required: "Country is required",
                        }}
                      />
                    )}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Message"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"message"}
                    type={"textarea"}
                    {...register("message", {
                      required: true,
                    })}
                    placeholder={"Message"}
                    error={errors.message}
                    messages={{
                      required: "Message is required",
                    }}
                    isEdit={isEdit}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <FileUpload
                    name="documents"
                    className={`p-4 w-[100%]`}
                    control={formMethods.control}
                    setValue={formMethods.setValue}
                    clearErrors={formMethods.clearErrors}
                    setError={formMethods.setError}
                    error={errors.documents}
                    messages={{
                      required: "File is required",
                    }}
                    required={false}
                    maxSize={20971520}
                    maxLable= "20MB"
                    label="Upload File"
                    acceptFiles="image/png, image/jpg, image/jpeg"
                    fileNames={fileName}
                    setFileName={setFileName}
                    isFileUploading={isFileUploading}
                    uploadedFiles={uploadedFiles}
                    setUploadedFiles={setUploadedFiles}
                    placeholder="Upload File (Max: 20 MB)"
                  />
                </div>
                <div className="flex justify-end">
                  <Button
                    type="button"
                    text={"Schedule for Later"}
                    className={`w-[100%] my-4 mr-4`}
                    secondary
                    smallBtn
                    onClick={handleScheduler}
                  />
                  <Button
                    type="submit"
                    text={"Send Now"}
                    className={`w-[100%] my-4`}
                    smallBtn
                  />
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </ModalDropdown>
    </>
  );
};

export default CreateNotifications;
